export const parseStreamId = (
  streamId: string
): { componentId: string; padName: string } => {
  const dotIndex = streamId.indexOf('.')
  if (dotIndex <= 0 || dotIndex === streamId.length - 1) {
    throw new Error(
      `Invalid streamId format: "${streamId}" - expected "componentId.padName"`
    )
  }
  return {
    componentId: streamId.slice(0, dotIndex),
    padName: streamId.slice(dotIndex + 1),
  }
}

/**
 * Like parseStreamId but returns null instead of throwing on malformed input.
 */
export const tryParseStreamId = (
  streamId: string
): { componentId: string; padName: string } | null => {
  const dotIndex = streamId.indexOf('.')
  if (dotIndex <= 0 || dotIndex === streamId.length - 1) {
    return null
  }
  return {
    componentId: streamId.slice(0, dotIndex),
    padName: streamId.slice(dotIndex + 1),
  }
}

let _tileCounter = 0

/** Generate a unique tile ID for layout identity. */
export const generateTileId = (): string =>
  `tile-${Date.now()}-${++_tileCounter}`
